import { Pressable } from 'react-native';
import { CopyPlus, EllipsisVertical } from 'lucide-react-native';
import { useTranslation } from 'react-i18next';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Icon } from '@/components/ui/icon';
import { Text } from '@/components/ui/text';
import { useWorkoutDuplicate } from '~/workout/hooks/useWorkoutDuplicate';
import type { WorkoutRecord } from '~/powersync/generated/schema';

export interface WorkoutHeaderMenuProps {
  workout: WorkoutRecord;
}

/**
 * Overflow (⋮) menu for the workout builder/detail header. Currently exposes
 * "Duplicate", which opens the duplicate-date dialog.
 */
export const WorkoutHeaderMenu = ({ workout }: WorkoutHeaderMenuProps) => {
  const { t } = useTranslation('workout');
  const { dispatchDuplicateDialog } = useWorkoutDuplicate();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Pressable
          testID="workout-header-menu"
          accessibilityRole="button"
          accessibilityLabel={t('duplicate.actionsLabel')}
          className="h-10 w-10 items-center justify-center rounded-full bg-surface active:opacity-70"
        >
          <Icon
            as={EllipsisVertical}
            size={20}
            className="text-text-secondary"
          />
        </Pressable>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem
          testID="workout-header-duplicate"
          onPress={() => dispatchDuplicateDialog(workout)}
        >
          <Icon as={CopyPlus} size={16} className="text-foreground" />
          <Text>{t('duplicate.action')}</Text>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
